import { memo, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./LandingPageHeader.module.scss";
import { ApplicationRoutes } from "../../../routes";
import { MenuIcon } from "../../../assets/icons";
import { useDispatch } from "react-redux";
import { logOut } from "../../../stores/slices/current-user-slice";
import { getUserType } from "../../../guards/common/authentification-functions";
import { UserType } from "../../../model/userType";

type Props = {
	onMenuButtonClick: () => void;
};

const LandingPageHeader: React.FC<Props> = memo((props: Props) => {
	const dispatch = useDispatch();
	const location = useLocation();
	let userType = getUserType();
	const isLoggedIn = useMemo(() => {
		if (!userType || userType === UserType.Guest) {
			return false;
		} else {
			return true;
		}
	}, [userType]);

	const { onMenuButtonClick } = props;

	const navigate = useNavigate();

	function navigateToLandingPage() {
		navigate(ApplicationRoutes.LANDING_PAGE);
	}

	function navigateToLogin() {
		navigate(ApplicationRoutes.LOGIN);
	}

	function navigateToSignup() {
		navigate(ApplicationRoutes.NEW_CUSTOMER_SIGNUP_USER_INFORMATION);
	}

	function navigateToFAQ(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
		event.preventDefault();
		navigate(ApplicationRoutes.FAQ);
	}

	function navigateToComingSoon(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
		event.preventDefault();
		navigate(ApplicationRoutes.COMING_SOON);
	}

	const logout = () => {
		dispatch(logOut());
		navigate(ApplicationRoutes.LANDING_PAGE);
	};

	const isRootPath = location.pathname === "/" ||  location.pathname === ApplicationRoutes.COMING_SOON || location.pathname === "/terms";

	return (
		<div className={styles.header}>
			<div className={styles.logoContainer} onClick={navigateToLandingPage}>
				<img height={30} src="../../../images/xepp-logo.svg" alt="Logo" />
			</div>
			<div className={styles.headerLinks}>
				{isRootPath && (
					<>
						<a className={styles.headerLink} href="/" onClick={navigateToComingSoon}>
							About
						</a>
						{/* <a className={styles.headerLink} href={ApplicationRoutes.FAQ} onClick={navigateToFAQ}>
							FAQ
						</a> */}
					</>
				)}
				{/* <button className={styles.signInBtn} onClick={isLoggedIn ? logout : navigateToLogin}>
					{isLoggedIn ? "Logout" : "Login"}
				</button>
				{!isLoggedIn && (
					<button className={styles.signInBtn} onClick={navigateToSignup}>
						Sign up
					</button>
				)} */}
			</div>
			<button className={styles.menuButton} onClick={onMenuButtonClick}>
				<MenuIcon />
			</button>
		</div>
	);
});

export default LandingPageHeader;
